import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { errorObjectToText } from '../../Utils/textTools';

function ErrorBlock({ description, message, show, className }) {
  if (!show) {
    return null;
  }

  if (Object(message) === message) {
    message = errorObjectToText(message);
  }

  return (
    <Alert
      message={message}
      description={description}
      type="error"
      showIcon
      className={className}
    />
  );
}

ErrorBlock.propTypes = {
  description: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  message: PropTypes.any,
  show: PropTypes.bool,
  className: PropTypes.string,
};

ErrorBlock.defaultProps = {
  description: '',
  message: 'Failed to load page data.',
  show: true,
  className: '',
};

export default ErrorBlock;
